import { PageMeta } from 'constants/pages';
import { Helmet } from 'react-helmet';

export const MetaHead: React.FC<{ pageMeta: PageMeta }> = ({ pageMeta }) => {
  const { title, description } = pageMeta;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};
